import { render, staticRenderFns } from "./TemplateNoteneingabe.vue?vue&type=template&id=4da57f3a"
import script from "./TemplateNoteneingabe.vue?vue&type=script&lang=js"
export * from "./TemplateNoteneingabe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports